import { render } from "./screen_reader_notice.vue?vue&type=template&id=4978e64a"
import script from "./screen_reader_notice.js?vue&type=script&lang=js"
export * from "./screen_reader_notice.js?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__